module.exports = __webpack_public_path__ + "static/img/dl_twitter.02d47139.png";